@if (!(platformRoute$ | async) && !embedService.embed) {
<app-header></app-header>
}
@if (!embedService.embed) {
  <app-platform-jobboard-login-modal />
}
<div class="router-wrapper" [class.platform-route]="platformRoute$ | async">
  <router-outlet></router-outlet>
</div>

@if (toastsService.toasts?.length > 0) {
<div class="toast-container">
  @for (toast of toastsService.toasts; track toast.id) {
  <ct-lib-toast [toast]="toast" (onDestroy)="toastsService.destroyToast($event)" @fadeInOutUp> </ct-lib-toast>
  }
</div>
}
@if (!(platformRoute$ | async)) {
<app-footer></app-footer>
}
